import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import App from 'components/App/App';
import { ConfirmBuyingLicenseComponent } from 'components/ConfirmBuyingLicense/ConfirmBuyingLicenseComponent';

const ConfirmBuyingLicense = ({}) => {
  return (
    <App>
      <ConfirmBuyingLicenseComponent />
    </App>
  );
};

export const getStaticProps = async ({ locale, locales }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      locale,
      locales,
    },
  };
};

export const getStaticPaths = async ({ locales }) => {
  const paths: StaticPath[] = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const locale of locales) {
    paths.push({ params: { type: 'stock_market' }, locale });
    paths.push({ params: { type: 'player' }, locale });
  }

  return {
    paths,
    fallback: true,
  };
};

export default ConfirmBuyingLicense;
